import { compose, isEmpty, getOr, isNull } from 'lodash/fp'
import NewClient from '../components/NewClient'
import { graphql } from 'react-apollo'
import gql from 'graphql-tag'
import {
  createValidator,
  composeValidators,
  combineValidators,
  isRequired,
  isAlphabetic
} from 'revalidate'
import validator from 'validator'
import withForm from 'utils/withForm'
import { branch, renderNothing } from 'recompose'

const AddNewCustomer = gql`
  mutation AddNewCustomer($customer: CustomerInput) {
    addCustomer(customer: $customer) {
      customerId
    }
  }
`

const UpdateCustomer = gql`
  mutation UpdateCustomer($customerId: ID!, $customer: CustomerInput) {
    updateCustomer(customerId: $customerId, customer: $customer) {
      customerId
    }
  }
`

const GetCustomer = gql`
  query GetCustomer($customerId: ID!) {
    getCustomer(customerId: $customerId) {
      firstName
      lastName
      email
      phoneNumbers {
        home
      }
      address {
        line1
        line2
        city
        state
        zipCode
      }
      vehicle {
        year
        make
        model
        trim
        vin
        plate
      }
    }
  }
`

const isEmail = createValidator(
  message => value => isEmpty(value) || validator.isEmail(value) ? null : message,
  field => 'Please provide a valid email'
)

const clientValidator = combineValidators({
  firstName: composeValidators(isRequired, isAlphabetic)('First Name'),
  lastName: composeValidators(isRequired, isAlphabetic)('Last Name'),
  email: composeValidators(
    isEmail
  )('Email')
})

const get = path => compose(
  value => isNull(value) ? '' : value,
  getOr('')(`getCustomer.${path}`)
)

export default compose(
  branch(props => !!props.customerId,
    compose(
      graphql(GetCustomer, {
        options: props => ({
          variables: {
            customerId: props.customerId
          },
          fetchPolicy: 'cache-and-network'
        })
      }),
      graphql(UpdateCustomer),
      branch(props => props.data.loading,
        renderNothing
      ),
      withForm({
        initialValues: ({ data }) => {
          return ({
            firstName: get('firstName')(data),
            lastName: get('lastName')(data),
            email: get('email')(data),
            phoneNumbers: {
              home: get('phoneNumbers.home')(data)
            },
            address: {
              line1: get('address.line1')(data),
              line2: get('address.line2')(data),
              city: get('address.city')(data),
              state: get('address.state')(data),
              zipCode: get('address.zipCode')(data)
            },
            vehicle: {
              year: get('vehicle.year')(data),
              make: get('vehicle.make')(data),
              model: get('vehicle.model')(data),
              trim: get('vehicle.trim')(data),
              vin: get('vehicle.vin')(data),
              plate: get('vehicle.plate')(data)
            }
          })
        },
        validator: clientValidator,
        onSuccess: (props, values) => props.mutate({
          variables: {
            customerId: props.customerId,
            customer: values
          },
          refetchQueries: ['GetCurrentCustomers']
        })
      })
    ),
    compose(
      graphql(AddNewCustomer),
      withForm({
        initialValues: {
          firstName: '',
          lastName: '',
          email: '',
          phoneNumbers: {
            home: ''
          },
          address: {
            line1: '',
            line2: '',
            city: '',
            state: '',
            zipCode: ''
          },
          vehicle: {
            year: null,
            make: '',
            model: '',
            trim: '',
            vin: '',
            plate: ''
          }
        },
        validator: clientValidator,
        onSuccess: (props, values) => props.mutate({
          variables: { customer: values },
          refetchQueries: ['GetCurrentCustomers']
        })
      })
    )
  )
)(NewClient)


// WEBPACK FOOTER //
// ./src/modules/clients/containers/NewClientForm.js